<template>
  <div>
    <v-container fluid>
      <v-card class="card">
        <v-toolbar color="primary" dark>
          <v-toolbar-title class="title">{{ $t('userprofile') }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>

        <v-layout flex align-center justify-center class="mt-4">
          <v-col cols="12" md="12">
            <div style="text-align: center;">
              <v-avatar size="180" color="#2B76D1" class="mt-5" @click="pickFile">
                <span class="white--text headline">{{ shotName }}</span>
              </v-avatar>
            </div>

            <div style="text-align: center">
              <p class="mt-4">
                <b>{{ $t('fusionFusion') }}</b>
              </p>
              <p>{{ username }}</p>
            </div>
          </v-col>
        </v-layout>
        <v-flex class="flex">
          <v-row>
            <v-col cols="12" md="3"></v-col>
            <v-col cols="12" md="3">
              <v-text-field :placeholder="$t('firstname')" :label="$t('firstname')" v-model="firstName" :rules="[() => !!firstName || $t('requiredField')]" required></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field :placeholder="$t('lastname')" :label="$t('lastname')" v-model="lastName" :rules="[() => !!lastName || $t('requiredField')]" required></v-text-field>
            </v-col>
            <v-col cols="12" md="3"></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3"></v-col>
            <v-col cols="12" md="3">
              <v-text-field :placeholder="$t('email')" :label="$t('email')" v-model="email" :rules="[rules.required, validateEmail(email)]"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field :placeholder="$t('phonenumber')" :label="$t('phonenumber')" v-mask="mask" v-model="mobile" :rules="[rules.required, PhoneNumberValidation(mobile)]"></v-text-field>
            </v-col>
            <v-col cols="12" md="3"></v-col>
          </v-row>
          <div style="text-align: center">
            <v-btn color="#1976D2" class="mt-10 mr-2" style="width: 14rem" outlined 
            @click="changPasswordDialog = true; password = ''; confirmpassword = ''; checkLengthPassword = true; checkLowercaseLetter = true;
            checkUppercaseLetter = true; checkNumber = true; checkSpecialCharacter = true; checkPasswordMatch = true;">{{ $t('changePassword') }}</v-btn>
            <v-btn color="#1976D2" class="mt-10 mr-2" @click="UpdateUser" style="width: 14rem" :loading="loading" :disabled="loading" outlined>
              <b>{{ $t('save') }}</b>
            </v-btn>
          </div>
 
          <br />
          <br />
          <br />
        </v-flex>
      </v-card>
    </v-container>
    <v-overlay :value="dialog">
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          {{ $t('loadingPleaseWait') }}
          <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </v-overlay>

    <!--dialog change password-->
    <v-dialog v-model="changPasswordDialog" width="600">
      <v-card>
        <v-card-title>{{ $t('changePassword') }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field ref="password" :label="$t('loginPwd')" :rules="[rules.required]" v-model="password"
                 outlined dense hide-details :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'"
                 @click:append="show1 = !show1"
                 :style="checkLengthPassword == true && 
                         checkLowercaseLetter == true &&
                         checkUppercaseLetter == true &&
                         checkNumber == true &&
                         checkSpecialCharacter == true ? 'margin-bottom: 26px;' : ''">
                  <template v-slot:append-outer>
                    <div style="position:absolute;">
                      <v-tooltip top max-width="40vw">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon text x-small style="position:absolute; top:0px; right:-6px"
                            v-bind="attrs"
                            v-on="on"
                            >mdi-information-outline</v-icon>
                        </template>
                        <span>{{$t('loginPwd')}}</span>
                      </v-tooltip> 
                    </div>
                  </template>
                </v-text-field> 
                <small>
                <v-row no-gutters>
                  <v-col cols="12">
                    <span :class="checkLengthPassword ? 'pass' : 'failed'">{{$t('checklengthcharacters')}}</span>
                  </v-col>
                  <v-col cols="12">
                    <span :class="checkLowercaseLetter ? 'pass' : 'failed'">{{$t('checklowercaseletter')}}</span>
                  </v-col>
                  <v-col cols="12">
                    <span :class="checkUppercaseLetter ? 'pass' : 'failed'">{{$t('checkuppercaseletter')}}</span>
                  </v-col>
                  <v-col cols="12">
                    <span :class="checkNumber ? 'pass' : 'failed'">{{$t('checknumber')}}</span>
                  </v-col>
                  <v-col cols="12">
                    <span :class="checkSpecialCharacter ? 'pass' : 'failed'">{{$t('checkspecialcharacter')}}</span>
                  </v-col>
                </v-row>
                </small>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field ref="confirmpassword" :label="$t('confirmPwd')" :rules="[rules.required]" v-model="confirmpassword"
                 outlined dense hide-details :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :type="show2 ? 'text' : 'password'"
                 @click:append="show2 = !show2"
                 :style="checkPasswordMatch == true ? 'margin-bottom: 26px;' : ''">
                  <template v-slot:append-outer>
                    <div style="position:absolute;">
                      <v-tooltip top max-width="40vw">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon text x-small style="position:absolute; top:0px; right:-6px"
                            v-bind="attrs"
                            v-on="on"
                            >mdi-information-outline</v-icon>
                        </template>
                        <span>{{$t('confirmPwd')}}</span>
                      </v-tooltip> 
                    </div>
                  </template>
                </v-text-field>
                <small>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <span :class="checkPasswordMatch ? 'pass' : 'failed'">{{ $t('checkPwdMatch') }}</span>
                    </v-col>
                  </v-row>
                </small>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeChangePassword">{{ $t('close') }}</v-btn>
          <v-btn color="blue darken-1" text @click="saveChangePassword">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios';
import Cookies from 'js-cookie';
import checkPermission from '@/api/function.js';
import store from '../store';
import { mask } from 'vue-the-mask';
export default {
  name: 'UserProfile',
  mixins: [checkPermission],
  directives: {
    mask,
  },
  data: () => ({
    mask: '##########',
    show1: false,
    show2: false,
    dialog: false,
    loading: false,
    userList: [],
    shotName: '',
    passwordOld: '',
    username: '',
    password:'',
    confirmpassword: '',
    usertype: '',
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    imageUrl: store.state.pathImage,
    imageName: '',
    imageFile: '',
    today: null,
    rules: {
      required: (value) => value === null || !!value || 'Required.',
    },

    checkLengthPassword: true,
    checkLowercaseLetter: true,
    checkUppercaseLetter: true,
    checkNumber: true,
    checkSpecialCharacter: true,
    checkPasswordMatch: true,
    statusFormatPassword: false,
    statusPassword: false,
    flagChangePassword: false,
    changPasswordDialog: false,
  }),

  watch: {
    password() {
      if (this.password != null && this.password != undefined && this.password != '') {
        this.checkLengthPassword = this.password.length >= 8;
        this.checkLowercaseLetter = /[a-z]/.test(this.password);
        this.checkUppercaseLetter = /[A-Z]/.test(this.password);
        this.checkNumber = /\d/.test(this.password);
        this.checkSpecialCharacter = /[^a-zA-Z0-9ก-๙]/.test(this.password);
        if (this.checkLengthPassword && this.checkLowercaseLetter && this.checkUppercaseLetter &&
            this.checkNumber && this.checkSpecialCharacter) {
          this.statusFormatPassword = true;
        } else {
          this.statusFormatPassword = false;
        }
        if (this.confirmpassword != null && this.password == this.confirmpassword) {
          this.checkPasswordMatch = true;
        } else if(this.confirmpassword != null && this.confirmpassword.length > 0) {
          this.checkPasswordMatch = false;
        }
      } else {
        this.statusFormatPassword = false;
      }
    },
    confirmpassword() {
      this.checkPasswordMatch = this.password == this.confirmpassword;
      if ((this.password != null && this.confirmpassword != null) &&
          (this.password == this.confirmpassword) &&
          this.checkLengthPassword && this.checkLowercaseLetter &&
          this.checkUppercaseLetter && this.checkNumber && this.checkSpecialCharacter) {
        this.statusPassword = true;

      } else{
        this.statusPassword = false;
      }
    }
  },
  methods: {
    PhoneNumberValidation(phno) {
      let phoneno = /^\d{10}$/;
      return phoneno.test(phno) || 'Please enter correct Phone Number';
    },

    validateEmail(email) {
      // eslint-disable-next-line no-useless-escape
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // NOSONAR
      return re.test(email) || 'Please enter correct Email';
    },
    pickFile() {
      this.$refs.image.click();
    },

    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) { // NOSONAR
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result.split(',')[1];
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = '';
        this.imageFile = '';
        this.imageUrl = '';
      }
    },
    GetUserManagement() {
      this.dialog = true;
      axios
        .post(`${this.url}EmployeeCom/GetEmployeeComAll`)
        .then((response) => {
          this.userList = response.data.data;
          this.dialog = false;
        })
        .catch((error) => {
          alert(error);
        });
    },
    Get() {
      this.dialog = true;
      this.$call.GetUserById(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.username = dataResponse.data.username;
            this.email = dataResponse.data.email;
            this.firstName = dataResponse.data.firstName;
            this.lastName = dataResponse.data.lastName;
            this.mobile = dataResponse.data.mobile;
            this.email = dataResponse.data.email;
            this.shotName = this.username.substring(0, 1).toUpperCase();
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    UpdateUser() {
      let emailvali = this.validateEmail(this.email);
      let phonevali = this.PhoneNumberValidation(this.mobile);
      if (emailvali == true && phonevali == true && this.firstName != '' && this.lastName != '') { // NOSONAR
        try {
          this.loading = true;
          let tempUser = {
            username: this.username,
            password: this.flagChangePassword ? this.password : "",
            idcard: 0,
            prefixId: 0,
            firstName: this.firstName,
            lastName: this.lastName,
            mobile: this.mobile,
            eMail: this.email,
          };
          this.$call.UpdateUserProfile(
            tempUser,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                this.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                Cookies.set('fullName', this.firstName + ' ' + this.lastName);
                store.state.fullName = this.firstName + ' ' + this.lastName;
                if (this.passwordOld != this.password) {
                  this.$call.ClearUserInfo();
                  this.$router.push('/login');
                }
              }
              this.loading = false;
            },
            (errorResource) => {
              this.loading = false;
              console.error(errorResource);
            }
          );
        } catch (error) {
          this.LogTrace(error, 'DeleteGroup');
        }
      } else {
        if (emailvali != true || phonevali != true) { // NOSONAR
          alert(this.$t('pleaseEnterCorrectFormat'));
        } else if (this.firstName == '' || this.lastName == '' || this.password == '' || this.confirmpassword == '' ||
                   this.password == null || this.confirmpassword == null) {
          alert(this.$t('pleaseFillAllTheFields'));
        }
        this.dialog = false;
      }
    },
    closeChangePassword() {
      this.password = '';
      this.confirmpassword = '';
      this.checkLengthPassword = true;
      this.checkLowercaseLetter = true;
      this.checkUppercaseLetter = true;
      this.checkNumber = true;
      this.checkSpecialCharacter = true;
      this.checkPasswordMatch = true;
      this.changPasswordDialog = false;
      this.show1 = false;
      this.show2 = false;
    },
    saveChangePassword() {
      try {
        this.dialog = true;
        if (this.password != '' && this.confirmpassword != '' && this.password != null && this.confirmpassword != null &&
            this.password != undefined && this.confirmpassword != undefined && this.password == this.confirmpassword &&
            this.checkPasswordMatch && this.checkLengthPassword && this.checkLowercaseLetter && this.checkUppercaseLetter &&
            this.checkNumber && this.checkSpecialCharacter) {
            let temp = {
              password : this.password,
          };
          this.$call.SaveChangePassword(
            temp,
              (dataResponse) => {
                if (dataResponse.status == 0) {
                  this.$swal.fire({
                    icon: 'success',
                    title: dataResponse.message,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.password = '';
                  this.confirmpassword = '';
                  this.checkLengthPassword = true;
                  this.checkLowercaseLetter = true;
                  this.checkUppercaseLetter = true;
                  this.checkNumber = true;
                  this.checkSpecialCharacter = true;
                  this.checkPasswordMatch = true;
                  this.changPasswordDialog = false;
                  this.show1 = false;
                  this.show2 = false;
                }
                else
                {
                  this.$swal.fire({
                    icon: 'warning',
                    title: dataResponse.data.message,
                    showConfirmButton: false,
                    timer: 1800,
                  });
                }
                this.dialog = false;
              },
              (errorResource) => {
                this.dialog = false;
                console.error(errorResource);
              }
            );
          } else {
            if ((this.password == '' || this.password == null || this.password == undefined) &&
            (this.confirmpassword != '' && this.confirmpassword != null && this.confirmpassword != undefined)) {
              this.$swal.fire({
                icon: 'warning',
                title: this.$t('warning'),
                text: this.$t('Please fill Password!'),
                showConfirmButton: false,
                timer: 2000,
              });
            } else if ((this.confirmpassword == '' || this.confirmpassword == null || this.confirmpassword == undefined) &&
            (this.password != '' && this.password != null && this.password != undefined)) {
              this.$swal.fire({
                icon: 'warning',
                title: this.$t('warning'),
                text: this.$t('Please fill Confirm Password!'),
                showConfirmButton: false,
                timer: 2000,
              });
            } else if (this.password == null && this.confirmpassword == null) {
              this.$swal.fire({
                icon: 'warning',
                title: this.$t('warning'),
                text: this.$t('Please fill Password and Confirm Password'),
                showConfirmButton: false,
                timer: 2000,
              });
            } else if (!this.checkLengthPassword || !this.checkLowercaseLetter || !this.checkUppercaseLetter || !this.checkNumber ||
             !this.checkSpecialCharacter) {
              this.$swal.fire({
                icon: 'warning',
                title: this.$t('warning'),
                text: this.$t('Please fill correct format!'),
                showConfirmButton: false,
                timer: 2000,
              });
            } else if (this.password != this.confirmpassword && !this.checkPasswordMatch) {
              this.$swal.fire({
                icon: 'warning',
                title: this.$t('warning'),
                text: this.$t('passwordMismatchFillCorrectly'),
                showConfirmButton: false,
                timer: 2000,
              });
            } else {
              this.$swal.fire({
                icon: 'warning',
                title: this.$t('warning'),
                text: this.$t('Please fill all the fields!!!'),
                showConfirmButton: false,
                timer: 2000,
              });
            }
            this.changPasswordDialog = true;
            this.dialog = false;
          }
      } catch (error) {
        this.LogTrace(error, 'saveChangePassword');
      }
    },
    decryptShiftData(encryptedText, shift) {
      let chars = encryptedText.split('');
      let decryptedChars = [];

      for (let c of chars) {
        if (/[a-zA-Z]/.test(c)) {
          let offset = c === c.toUpperCase() ? 'A'.codePointAt(0) : 'a'.codePointAt(0);
          c = String.fromCodePoint(((c.codePointAt(0) - offset - shift + 26) % 26) + offset);
        } else if (/\d/.test(c)) {
          c = String.fromCodePoint(((c.codePointAt(0) - '0'.codePointAt(0) - shift + 10) % 10) + '0'.codePointAt(0));
        }

        decryptedChars.push(c);
      }

      return decryptedChars.join('');
    },
  },
  mounted() {
    this.GetDate();
    this.Get();
  },
};
</script>
<style scoped>
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}
.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
.circular--portrait {
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
  border-radius: 50%;
}

.circular--portrait img {
  width: 100%;
  height: auto;
}

.pass {
  display: none;
}

.failed {
  display: block;
  color: red;
}

.ChangePassword:hover {
  background-color: #1976d2 !important;
  color: white !important;
}
</style>
